// extracted by mini-css-extract-plugin
export default {"pageContent":"dmfnBR9IGGXHi8G0W5ce__pageContent___","verticalNavLayout":"d10fUIQZlqxdg9lfaVSL__verticalNavLayout___"};